import { render, staticRenderFns } from "./EducationalCoursesList.vue?vue&type=template&id=6b8f4517&"
import script from "./EducationalCoursesList.vue?vue&type=script&lang=js&"
export * from "./EducationalCoursesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports